import { render, staticRenderFns } from "./HchospitalizacionMobile.vue?vue&type=template&id=1b611484&scoped=true"
import script from "./HchospitalizacionMobile.vue?vue&type=script&lang=js"
export * from "./HchospitalizacionMobile.vue?vue&type=script&lang=js"
import style0 from "./HchospitalizacionMobile.vue?vue&type=style&index=0&id=1b611484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b611484",
  null
  
)

export default component.exports